import React from 'react'
import './LockInChartChips.component.css'
import { IonChip, IonLabel } from '@ionic/react'
import { useTranslation } from 'react-i18next'
import { useOfflineStatus } from '../../../utilities/isOnline.util'

type LockInChartChipsProps = {
  isChartLockedIn: number
  chartStatus: string
}

const LockInChartChips: React.FC<LockInChartChipsProps> = ({ isChartLockedIn, chartStatus }) => {
  const { t } = useTranslation()
  const isOfflineStatus = useOfflineStatus()

  const renderChip = () => {
    if (isChartLockedIn === 1 && isOfflineStatus === true) {
      return (
        <IonChip className='offline-errors-fixed-chip'>
          <IonLabel>{t('completeChart.offlineErrorsFixed')}</IonLabel>
        </IonChip>
      )
    }
    if (isChartLockedIn === 1 && isOfflineStatus === false) {
      return (
        <IonChip className='locked-ready-to-upload-chip sc-success-bold'>
          <IonLabel>{t('completeChart.lockedReadyToUpload')}</IonLabel>
        </IonChip>
      )
    }
    return (
      <IonChip outline>
        <IonLabel>{chartStatus}</IonLabel>
      </IonChip>
    )
  }

  return <>{renderChip()}</>
}

export default LockInChartChips
